import * as React from "react";
import { useAuth } from "./context/auth-context";
//import { useOktaAuth } from "@okta/okta-react";
import FullPageSpinner from "./screens/components/elements/FullPageSpinner";

const AuthenticatedApp = React.lazy(() =>
  import(/* webpackPrefetch: true */ "./authenticated-app")
);
const UnauthenticatedApp = React.lazy(() => import("./unauthenticated-app"));

function App() {
  const { isLoggedIn, userInfo } = useAuth();

  let hasUserInfo =
    typeof userInfo === "undefined" || userInfo === null ? false : true;

  // passing hasToken for a case where token was obtained but userinfo failed

  return (
    <React.Suspense fallback={<FullPageSpinner />}>
      {isLoggedIn && hasUserInfo ? (
        <AuthenticatedApp />
      ) : (
        <UnauthenticatedApp hasToken={isLoggedIn} />
      )}
    </React.Suspense>
  );
}

//export { App };
export default App;
